import { environment } from '../../environments/environment';
import { SelectItem } from 'primeng/primeng';

export class Filter {
  locale_es = environment.datepickerConfig;

  constructor() {}

  parseDropdownResults(results, modelHandler, label, allOption = true) {
    const collection = [];
    if (allOption) {
      collection.push({ label: 'Todos', value: null });
    }
    for (let item of results) {
      item = modelHandler.apiMap(item);
      collection.push({ label: item[label], value: item });
    }
    return collection;
  }

  selectDropdownItem(collection, filterId) {
    let selected = null;
    for (const item of collection) {
      if (item.id === filterId) {
        selected = item;
        break;
      }
    }

    return selected;
  }

  selectMultipleDropdownItems(collection, filterIds) {
    const selected: any[] = [];

    if (!filterIds) {
      return selected;
    }

    if (!Array.isArray(filterIds)) {
      filterIds = [filterIds];
    }

    for (const item of collection) {
      if (filterIds.indexOf(item.id) > -1) {
        selected.push(item);
      }
    }

    return selected;
  }

  protected getCollection(service, model) {
    const promise = new Promise((resolve, reject) => {
      service.list(1, 10000, '', '').subscribe(
        (response) => {
          resolve(response.results);
        },
        (error) => {
          reject(false);
        }
      );
    });

    return promise;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/filter.ts